import { Form } from "./form";
import { ensureElement } from "../utils/utils";
export class Contacts extends Form {
    constructor(container, events) {
        super(container, events);
    }
    set phone(value) {
        this.container.elements.namedItem('phone').value = value;
    }
    set email(value) {
        this.container.elements.namedItem('email').value = value;
    }
}
export class Shipping extends Form {
    constructor(container, events, actions) {
        super(container, events);
        this._cardBtn = ensureElement('button[name="card"]', this.container);
        this._cashBtn = ensureElement('button[name="cash"]', this.container);
        if (this._cardBtn && this._cashBtn) {
            this._cardBtn.classList.add('button_alt-active');
        }
        if (actions === null || actions === void 0 ? void 0 : actions.onClick) {
            this._cardBtn.addEventListener('click', actions.onClick);
            this._cashBtn.addEventListener('click', actions.onClick);
        }
        else {
            console.error('Не найдена кнопка');
        }
    }
    toggleButton(target) {
        this._cardBtn.classList.toggle('button_alt-active');
        this._cashBtn.classList.toggle('button_alt-active');
    }
    set address(value) {
        this.container.elements.namedItem('address').value = value;
    }
}
